module.exports = __webpack_public_path__ + "img/codec-logo.5d5bca13.png";